<span class="sort-icon-stack">
    <span class="material-icons-round sort-icon" [ngClass]="{'active': direction === 'asc'}">expand_less</span>
    <span class="material-icons-round sort-icon" [ngClass]="{'active': direction === 'desc'}">expand_more</span>
  </span>
